import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getDataPromociones = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/promociones/getDataPromociones`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deletePromocion = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/promociones/deletePromocion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updatePromocion = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/promociones/updatePromocion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const savePromocion = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/promociones/savePromocion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const promocionesService = {
    getDataPromociones,
    deletePromocion,
    updatePromocion,
    savePromocion
};